import { useLocation } from "react-router-dom";

import NavBarComponent from "./navbar";
import LeftBarComponent from "./leftbar";
import NewsComponent from "./news";
import RightBarComponent from "./rightbar";
import CharacterProfileComponent from "./character_profile";
import AdminPanelComponent from "./admin_panel";

import './index.css';

const HomeComponent = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const pathSplit = currentPath.split('/');
    const mainPath = pathSplit[1];
    const characterId = pathSplit[2];
    const isAdminPage = mainPath === 'admin';

    const renderMainContent = () => {
        if (isAdminPage) return <AdminPanelComponent />;
        if (mainPath === 'character' && characterId) return <CharacterProfileComponent id={characterId}/>;
        return <NewsComponent />;
    };

    return (
        <div id="home-container">
            <div id='home-shell'>
                <NavBarComponent />

                <div id='home-content-container'>
                    {renderMainContent()}
                    {!isAdminPage && <RightBarComponent />}
                </div>
            </div>

            <LeftBarComponent />

        </div>
    );
};

export default HomeComponent;